type DiagnosisRecommendSelection = {
  value?: number | string | null
}

export const buildDiagnosisRecommendsPayload = (selections: DiagnosisRecommendSelection[] = []) => (
  selections
    .map((selection) => Number(selection?.value))
    .filter((recommendId) => recommendId > 0)
    .map((recommendId) => ({ recommendId }))
)

// Only these errors have a visible helper text in FormDiagnosis. Other server
// errors must be shown as a toast, not stored in an undisplayed form field.
const diagnosisFieldErrorKeys = new Set([
  'DIAGNOSIS_TYPE_NAME', 'DIAGNOSIS_CODE', 'IS_DUPLICATE_DIAGNOSIS_CODE',
  'DIAGNOSIS_CODE_STRING_BASE', 'DIAGNOSIS_CODE_STRING_EMPTY',
  'DIAGNOSIS_CODE_MAXIMUM_LENGTH', 'DIAGNOSIS_CODE_ANY_REQUIRED',
  'DIAGNOSIS_NAME', 'IS_DUPLICATE_DIAGNOSIS_NAME', 'DIAGNOSIS_NAME_STRING_BASE',
  'DIAGNOSIS_NAME_STRING_EMPTY', 'DIAGNOSIS_NAME_MAXIMUM_LENGTH', 'DIAGNOSIS_NAME_ANY_REQUIRED'
])

export const resolveDiagnosisSubmitError = (error: any, operation: 'CREATE' | 'UPDATE') => {
  const response = error?.response || (typeof error?.status === 'number' ? error : undefined)
  if (!response) return { fieldKeys: [] as string[], toastKey: 'CONNECTION_ERROR' }

  const message = response.data?.message
  const messages = Array.isArray(message) ? message : [message]
  const fieldKeys = messages.filter((key): key is string => typeof key === 'string' && diagnosisFieldErrorKeys.has(key))
  const hasUnsupportedError = !messages.length || messages.some(key => !diagnosisFieldErrorKeys.has(key))
  return { fieldKeys, toastKey: hasUnsupportedError ? `${operation}_FAILED` : null }
}
